import { config } from "_config";
import { authHeader, customerUid, getApiProxyUrl, handleResponse, mappingQueryParams } from "_helpers";

const { customerApiUrl, ordersApiUrl } = config;

export const customerService = {
  getPaymentMethods,
  crmGetPaymentMethods,
  postPaymentMethod,
  crmPostPaymentMethod,
  getSubscriptions,
  crmGetSubscriptions,
  postCancelSubscriptions,
  crmPostCancelSubscriptions,
  getRequiredActions,
  crmGetRequiredActions,
  resolveRequiredAction,
  crmResolveRequiredAction,
};

function getPaymentMethods() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const url = `${customerApiUrl}/customers/${customerUid()}/payment-methods`;

  return fetch(url, requestOptions).then(handleResponse);
}

function crmGetPaymentMethods() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const url = `${getApiProxyUrl()}/customers/${customerUid()}/payment-methods`;

  return fetch(url, requestOptions).then(handleResponse);
}

function postPaymentMethod(cardDetails) {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(cardDetails),
  };

  const url = `${customerApiUrl}/customers/${customerUid()}/payment-methods`;

  return fetch(url, requestOptions).then(handleResponse);
}

function crmPostPaymentMethod(cardDetails) {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(cardDetails),
  };

  const url = `${getApiProxyUrl()}/customers/${customerUid()}/payment-methods`;

  return fetch(url, requestOptions).then(handleResponse);
}

function getSubscriptions() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const url = `${customerApiUrl}/customers/${customerUid()}/subscriptions`;

  return fetch(url, requestOptions).then(handleResponse);
}

function crmGetSubscriptions() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const url = `${getApiProxyUrl()}/customers/${customerUid()}/subscriptions`;

  return fetch(url, requestOptions).then(handleResponse);
}

function postCancelSubscriptions(orderId, productId, refund, isRawResponse) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
  };

  let url = `${ordersApiUrl}/orders/${orderId}/products/${productId}/cancel-subscription`;

  if (refund) {
    url += "?refund=true";
  }

  if (isRawResponse) {
    return fetch(url, requestOptions);
  }

  return fetch(url, requestOptions).then(handleResponse);
}

function crmPostCancelSubscriptions(orderId, productId) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
  };

  const url = `${getApiProxyUrl()}/orders/${orderId}/products/${productId}/cancel-subscription`;

  return fetch(url, requestOptions).then(handleResponse);
}

function getRequiredActions() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const url = `${customerApiUrl}/customers/${customerUid()}/required-actions${mappingQueryParams({
    brandCategory: "TRADEMARKS",
  })}`;

  return fetch(url, requestOptions).then(handleResponse);
}

function crmGetRequiredActions() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const url = `${getApiProxyUrl()}/customers/${customerUid()}/required-actions${mappingQueryParams({
    brandCategory: "TRADEMARKS",
  })}`;

  return fetch(url, requestOptions).then(handleResponse);
}

function resolveRequiredAction(actionId) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
  };

  const url = `${customerApiUrl}/customers/${customerUid()}/required-actions/${actionId}/mark-resolved`;

  return fetch(url, requestOptions).then(handleResponse);
}

function crmResolveRequiredAction(actionId) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
  };

  const url = `${getApiProxyUrl()}/customers/${customerUid()}/required-actions/${actionId}/mark-resolved`;

  return fetch(url, requestOptions).then(handleResponse);
}
